<nb-layout>
  <nb-layout-column class="authentication-page-container">
    <ng-container *ngIf="isAuthenticated$ | async as data">
      <div class="authentication-page">
        <div class="authentication-card-container">
        <nb-card class="authentication-page-card">
          <nb-card-body>
            <img
              src="/assets/theme/Logo_ParkBase.png"
              alt="Logo Parkbase"
              width="225"
              height="50"
            />
            <h6>v{{ version }}</h6>
            <ng-container *ngIf="data.isAuthenticated; else noAuth">
              <button
                nbButton
                fullWidth
                shape="semi-round"
                status="primary"
                id="logout"
                (click)="logout(configurations[0].configId)"
              >
                <span translate>{{ "LOGOUT" }}</span>
              </button>
              <br />
            </ng-container>
            <ng-template #noAuth>
              <div class="login-button" *ngFor="let config of configurations">
                <button
                  nbButton
                  fullWidth
                  shape="semi-round"
                  status="primary"
                  id="login"
                  (click)="login(config.configId)"
                >
                  <span translate>{{ "LOGIN" }}</span>
                </button>
              </div>
            </ng-template>
          </nb-card-body>
        </nb-card>
        </div>
      </div>
    </ng-container>
  </nb-layout-column>
</nb-layout>
